import React, { Component } from 'react';
import { translate } from 'react-i18next';
import {withRouter} from 'react-router-dom';
import { connect } from 'react-redux';

import {getCarouselItems} from 'reducers/carouselItems.js';
import Utils from 'utils/Utils.js';
import {mod} from 'utils/MathUtils.js';
import Carousel from './Carousel.js';


const autoScrollPeriod   = 5000;
const transitionDuration = 1000;


class CarouselContainer extends Component {
    constructor(props){
        super(props);
        this.state = {offset:0, autoScrollDisableTime:null, transitionEndsAt: null};
        this.onNext = this.onNext.bind(this);
        this.onClickCarousel = this.onClickCarousel.bind(this);
        this.onClickCarouselIndicator = this.onClickCarouselIndicator.bind(this);
        this.autoScroll = this.autoScroll.bind(this);
        this.onNavigate = this.onNavigate.bind(this);
    }

    componentWillMount() {
        this.autoScrollTimerID = setInterval(this.autoScroll, autoScrollPeriod);
    }

    componentWillUnmount() {
        clearInterval(this.autoScrollTimerID);
    }

    autoScroll() {
        if((!document.hidden) &&
           (this.state.autoScrollDisableTime === null || (new Date()).getTime() > this.state.autoScrollDisableTime) && 
           (this.props.carouselItems.length > 1)) {
            this.onNext(1, true);
        }
    }

    onNavigate(item) {
        var inTransition = Boolean(this.state.transitionEndsAt && this.state.transitionEndsAt > (new Date()).getTime());
        if(inTransition) {
            return;
        }

        var navigation = item.navigation;
        if(navigation) {
            var route = navigation.route;
            if(route) {
                this.props.history.push(route);
            }
        }
    }

    onClickCarousel(info) {
        if(info.carouselPosition != 0) {
            this.onNext(info.carouselPosition);
        } else {
            this.onNavigate(info.carouselItem);
        }
    }

    onClickCarouselIndicator(i, offset, carouselItems) {
        var numItems = carouselItems.length || 1;
        var offset = mod(offset, numItems);
        var deltaA = mod(i-offset, numItems);
        var deltaB = -(numItems-deltaA);
        if(Math.abs(deltaA) <= Math.abs(deltaB)) {
            this.onNext(deltaA);
        } else {
            this.onNext(deltaB);
        }
    }

    onNext(inc, auto) {
        var autoScrollDisable = {};
        if(!auto) {
            autoScrollDisable = {autoScrollDisableTime:(new Date()).getTime() + autoScrollPeriod};
        }
        this.setState(state => ({offset:state.offset+inc,
                                 transitionEndsAt:(new Date()).getTime() + transitionDuration, 
                                 ...autoScrollDisable}));
    }

    getCarouselPositions(carouselItems) {
        var numCarouselItems = carouselItems.length;
        var halfWidth = (numCarouselItems > 4) ? numCarouselItems : numCarouselItems*2; 
        var result = [];
        for(var i = -halfWidth; i < halfWidth; i++) {
            result.push({position:i, noTransition:(i===-halfWidth || i === halfWidth-1)});
        }
        return result;
    }

    render() {
        return <Carousel carouselItems={this.props.carouselItems}
                         carouselPositions={this.getCarouselPositions(this.props.carouselItems)}
                         offset={this.state.offset}
                         onNext={this.onNext}
                         onClickCarousel={this.onClickCarousel}
                         onClickCarouselIndicator={this.onClickCarouselIndicator}
                         onNavigate={this.onNavigate}
                            />;
    }

}

const mapStateToProps = (state) => {
    return {carouselItems:getCarouselItems(state.carouselItems),
           };
};

export default withRouter(connect(mapStateToProps)(translate('challenges')(CarouselContainer)));



// WEBPACK FOOTER //
// ./src/modules/challenges/CarouselContainer.js